export default "__VITE_ASSET__NQuCkRqs__"